import { Controller } from "stimulus";
import OpSlider from "~/scripts/components/opSlider/opSlider";

const CLASS_SELECTED = "is-selected";
const CLEAR_CHECK = "product-slider__slide--clear-cut";
const IS_CLEAR = "is-clear-cut";

export default class extends Controller {
    selectedIndex = null;

    static targets = [
        "slider",
        "frame",
        "list",
        "clearCut",
        "slide",
        "dot",
        "thumbSlider",
        "thumbFrame",
        "thumbList",
        "thumbSlide",
        "caption"
    ];

    initialize() {
        this.onLoad = this.onLoad.bind(this);
        this.select = this.select.bind(this);
        this.imageSlide = this.imageSlide.bind(this);
    }

    connect() {
        this.onLoad();
    }

    onLoad() {
        this.select(0);
        this.thumbSlider = new OpSlider({
            slider: this.thumbSliderTarget,
            frame: this.thumbFrameTarget,
            list: this.thumbListTarget,
            slides: this.thumbSlideTargets,
            mode: {
                // centered: true,
                fill: true,
                // infinite: true,
                multiple: true
                // loop: true,
            }
            // autoplay: {
            //     duration: 4000,
            //     pauseOnHover: true,
            // },
        });
        this.imageSlider = new OpSlider({
            slider: this.sliderTarget,
            frame: this.frameTarget,
            list: this.listTarget,
            slides: this.slideTargets,
            onSelect: this.imageSlide,
            animationAllowed: false,
            dragAllowed: true,
            mode: {}
        });
    }

    dotClick(event) {
        const index = parseInt(event.target.getAttribute("data-index")) - 1;
        this.thumbSlider.select(index);
        this.imageSlider.select(index);
        this.select(index);
    }

    imageSlide(index) {
        this.thumbSlider.select(index);
        this.select(index);
    }

    thumbClick(event) {
        const index =
            parseInt(event.currentTarget.getAttribute("data-index")) - 1;
        this.select(index);
    }

    select(index) {
        if (this.selectedIndex === index) return;
        this.selectedIndex = index;

        for (let target of this.dotTargets) {
            target.classList.remove(CLASS_SELECTED);
        }

        for (let target of this.thumbSlideTargets) {
            target.classList.remove(CLASS_SELECTED);
        }

        for (let target of this.slideTargets) {
            target.classList.remove(CLASS_SELECTED);
        }

        for (let target of this.captionTargets) {
            target.classList.remove(CLASS_SELECTED);
        }

        const dotTarget = this.dotTargets[this.selectedIndex];
        if (dotTarget) {
            dotTarget.classList.add(CLASS_SELECTED);
        }

        const currentSlide = this.slideTargets[this.selectedIndex];
        if (currentSlide.classList.contains(CLEAR_CHECK)) {
            this.clearCutTarget.classList.add(IS_CLEAR);
        } else {
            this.clearCutTarget.classList.remove(IS_CLEAR);
        }

        this.thumbSlideTargets[this.selectedIndex].classList.add(
            CLASS_SELECTED
        );
        this.slideTargets[this.selectedIndex].classList.add(CLASS_SELECTED);
        this.captionTargets[this.selectedIndex].classList.add(CLASS_SELECTED);
    }
}



// WEBPACK FOOTER //
// ./public/assets/scripts/controllers/product-slider_controller.js